import jwt from 'jsonwebtoken';
import createReducer from '../../utils/createReducer';
import {
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  AUTHENTICATE_USER_SUCCESS,
  AUTHENTICATE_USER_ERROR,
  INIT_USER_SUCCESS,
  INIT_USER_ERROR,
  RESET_USER,
  REFRESH_TOKENS_SUCCESS,
  REFRESH_TOKENS_ERROR,
  GENERATE_TOKEN_SUCCESS,
  GENERATE_TOKEN_ERROR,
  SET_LOGON_UID,
  GET_BASIC_ACCOUNT_SUCCESS,
  USERNAMES_FETCH_SUCCESS,
  CREATE_PLAIN_USER_SUCCESS,
  CREATE_PLAIN_USER_ERROR,
} from '../../actions/user/userActionConstants';
import {
  AUTHENTICATE_SALES_ASSISTED_ERROR,
  AUTHENTICATE_SALES_ASSISTED_SUCCESS,
} from '../../actions/salesAssisted/salesAssistedActionContants';

const initialState = {
  user: {},
  tokens: {},
  error: '',
  logonUid: '',
  basicAccount: {},
  usernames: [],
};

export default createReducer(
  {
    [CREATE_USER_SUCCESS]: createUser,
    [CREATE_USER_ERROR]: createUserError,
    [AUTHENTICATE_SALES_ASSISTED_SUCCESS]: authenticateUser,
    [AUTHENTICATE_SALES_ASSISTED_ERROR]: authenticateUserError,
    [AUTHENTICATE_USER_SUCCESS]: authenticateUser,
    [AUTHENTICATE_USER_ERROR]: authenticateUserError,
    [INIT_USER_SUCCESS]: initUser,
    [INIT_USER_ERROR]: initUserError,
    [REFRESH_TOKENS_SUCCESS]: refreshTokens,
    [REFRESH_TOKENS_ERROR]: refreshTokensError,
    [RESET_USER]: resetUser,
    [GENERATE_TOKEN_SUCCESS]: generateToken,
    [GENERATE_TOKEN_ERROR]: generateTokenError,
    [SET_LOGON_UID]: setLogonUid,
    [GET_BASIC_ACCOUNT_SUCCESS]: setBasicAccount,
    [USERNAMES_FETCH_SUCCESS]: setUsernames,
    [CREATE_PLAIN_USER_SUCCESS]: createPlainUser,
    [CREATE_PLAIN_USER_ERROR]: createPlainUserError,
  },
  initialState,
);

function setUsernames(state, action) {
  return {
    ...state,
    usernames: action.payload,
  };
}

function createUser(state, { payload }) {
  const { IsExistingUser, JwtToken, JwtRefreshToken } = payload;
  const user = jwt.decode(JwtToken);

  return {
    ...state,
    user: {
      IsExistingUser,
      ...user,
    },
    tokens: {
      JwtToken,
      JwtRefreshToken,
    },
  };
}

function createUserError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function authenticateUser(state, { payload }) {
  const { IsExistingUser, JwtToken, JwtRefreshToken } = payload;
  const user = jwt.decode(JwtToken);

  return {
    ...state,
    user: {
      IsExistingUser,
      ...user,
    },
    tokens: {
      JwtToken,
      JwtRefreshToken,
    },
    error: '',
  };
}

function authenticateUserError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function createPlainUser(state, { payload }) {
  const { IsExistingUser, JwtToken, JwtRefreshToken } = payload;
  const user = jwt.decode(JwtToken);

  return {
    ...state,
    user: {
      IsExistingUser,
      ...user,
    },
    tokens: {
      JwtToken,
      JwtRefreshToken,
    },
    error: '',
  };
}

function createPlainUserError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function initUser(state, { payload }) {
  const { JwtToken, JwtRefreshToken } = payload;
  const user = jwt.decode(JwtToken);

  return {
    ...state,
    user: {
      ...user,
    },
    tokens: {
      JwtToken,
      JwtRefreshToken,
    },
  };
}

function initUserError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function refreshTokens(state, { payload }) {
  const { JwtToken, JwtRefreshToken } = payload;
  const user = jwt.decode(JwtToken);

  return {
    ...state,
    user: {
      ...user,
    },
    tokens: {
      JwtToken,
      JwtRefreshToken,
    },
    error: '',
  };
}

function refreshTokensError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function resetUser() {
  return {
    user: {},
    tokens: {},
    error: '',
  };
}

function generateToken(state, action) {
  return {
    ...state,
    tokens: action.payload,
  };
}

function generateTokenError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}

function setLogonUid(state, action) {
  return {
    ...state,
    logonUid: action.payload,
  };
}

function setBasicAccount(state, action) {
  return {
    ...state,
    basicAccount: { ...action.payload },
  };
}
